"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=star.js.map